import { useState } from "react";
import { Sparkles, Info, X } from "lucide-react";

// Badge versione nel portale cliente: "Versione Pro" se attiva, altrimenti "Passa a Versione Pro"
// con una (i) che apre un popup con descrizione e immagine di confronto.
export function VersioneProBadge({ pro }) {
  const [open, setOpen] = useState(false);
  if (pro)
    return (
      <span data-testid="cliente-pro-badge" className="inline-flex shrink-0 items-center gap-1 rounded-full bg-gradient-to-r from-[#C17F59] to-[#9d6a4a] px-2.5 py-0.5 text-[10px] font-extrabold uppercase tracking-wider text-white shadow-sm">
        <Sparkles className="h-3 w-3" />Versione Pro
      </span>
    );
  return (
    <>
      <button type="button" onClick={() => setOpen(true)} data-testid="passa-pro-btn"
        className="inline-flex shrink-0 items-center gap-1.5 rounded-full border border-[#C17F59]/40 bg-[#FBF3EE] px-3 py-1 text-[11px] font-bold text-[#9d6a4a] transition-colors hover:bg-[#f6e7dd]">
        Passa a Versione Pro<Info className="h-3.5 w-3.5" />
      </button>
      {open && (
        <div className="fixed inset-0 z-[95] flex items-end justify-center bg-black/50 sm:items-center sm:p-4" onClick={() => setOpen(false)} data-testid="passa-pro-dialog">
          <div className="max-h-[92vh] w-full max-w-lg overflow-y-auto rounded-t-3xl bg-white p-5 shadow-2xl sm:rounded-3xl" onClick={(e) => e.stopPropagation()}>
            <div className="mb-3 flex items-start justify-between gap-3">
              <div className="flex items-center gap-2">
                <span className="flex h-9 w-9 items-center justify-center rounded-2xl bg-gradient-to-r from-[#C17F59] to-[#9d6a4a] text-white"><Sparkles className="h-5 w-5" /></span>
                <h3 className="text-lg font-extrabold text-slate-900">Versione Pro</h3>
              </div>
              <button type="button" onClick={() => setOpen(false)} className="rounded-full p-2 text-slate-400 hover:bg-slate-100" aria-label="Chiudi" data-testid="passa-pro-close"><X className="h-5 w-5" /></button>
            </div>
            <p className="mb-4 text-sm leading-relaxed text-slate-600">La <b>Versione Pro</b> sblocca le funzioni avanzate pensate per le aziende: <b>domande illimitate</b> a Vesta e <b>report mensili</b>, <b>dettaglio tecnico degli allarmi</b> con <b>richiesta d'intervento</b> diretta a Torri, per l'auto la <b>ricarica a PUN</b> con scelta del modello e stima del risparmio, <b>esportazione dati (CSV)</b>, <b>salva schermo personalizzato</b> con logo e video aziendale, il <b>logo della tua azienda</b> nel portale e <b>più accessi</b> per i referenti.</p>
            <img src="/confronto-versione-pro.png" alt="Confronto tra versione Normale e Versione Pro" className="w-full rounded-2xl ring-1 ring-slate-100" data-testid="passa-pro-img" />
            <p className="mt-4 rounded-2xl bg-[#FBF3EE] p-3 text-center text-sm font-semibold text-[#9d6a4a]">Chiedi al tuo installatore Torri per attivare la Versione Pro.</p>
          </div>
        </div>
      )}
    </>
  );
}
